// extracted by mini-css-extract-plugin
export default {"slider":"style_slider__rRtSM","unSliderCard":"style_unSliderCard__sJpEC","nextBtn":"style_nextBtn__Fx-xR","preBtn":"style_preBtn__UnjdS"};